import React from "react";
import {
  Home as HomeIcon,
  Compass,
  HeartPulse,
  Settings as SettingsIcon,
} from "lucide-react";

// IMPORTANT: use "myhealth" to match PatientShell activeTab
const TABS = [
  { id: "home", label: "Home", icon: HomeIcon },
  { id: "explore", label: "Explore", icon: Compass },
  { id: "myhealth", label: "My Health", icon: HeartPulse },
  { id: "settings", label: "Settings", icon: SettingsIcon },
];

export default function BottomNav({ activeTab, onChange }) {
  return (
    <nav className="p2-bottom-nav">
      <div className="p2-bottom-nav-inner">
        {TABS.map(({ id, label, icon: Icon }) => {
          const active = activeTab === id;
          return (
            <button
              key={id}
              type="button"
              onClick={() => onChange?.(id)}
              className="p2-bottom-nav-item"
            >
              <span
                className={
                  "p2-bottom-nav-icon" +
                  (active ? " p2-bottom-nav-icon--active" : "")
                }
              >
                <Icon className="p2-bottom-nav-icon-svg" />
              </span>
              <span
                className={
                  "p2-bottom-nav-label" +
                  (active ? " p2-bottom-nav-label--active" : "")
                }
              >
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
